import Sell from './Sell';

export default Sell;
